import { createFileRoute } from '@tanstack/react-router';

import { homeScreen } from '@/app/home.screen';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// A Início chega sob demanda (U51): a mesa, os favoritos, os recentes, o pulso e o Luy ficam fora do JS
// inicial da casca; as contagens carregam as portas dos módulos só quando a tela pede.
export const Route = createFileRoute('/_app/')({
  staticData: { screen: homeScreen },
  component: lazyScreen(() => import('@/app/home/home-screen'), 'HomeScreen'),
});
